module.exports = __webpack_public_path__ + "static/media/calabashHeroBannerCard.5bdcb570.png";